<template>
    <div class="wrapper">
        <div class="section section-blogs-2 topsearch">
            <div class="container main">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <router-link
                            id="buttonback"
                            :to="{ name: 'saleschannalList' }"
                        >
                            <md-icon>keyboard_arrow_left</md-icon>
                            Назад к списку справочников
                        </router-link>
                    </div>
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <div class="name">
                            <h3 class="title">
                                Редактирование элемента справочника каналов
                                продаж:
                            </h3>
                            <div
                                v-if="chanel"
                                class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep"
                            >
                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('chanName')"
                                    >
                                        <label>{{
                                            mapElementName['chanName']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            v-model="form['chanName']"
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['chanName']"
                                            type="text"
                                        ></md-input>
                                        <span
                                            class="md-error"
                                            v-if="!$v.form.chanName.required"
                                            >Обязательно для заполнения</span
                                        >
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="
                                            getValidationClass('utmSubstring')
                                        "
                                    >
                                        <label>{{
                                            mapElementName['utmSubstring']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            readonly
                                            v-model.number="
                                                form['utmSubstring']
                                            "
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['utmSubstring']"
                                            type="text"
                                        ></md-input>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('officeId')"
                                    >
                                        <label>{{
                                            mapElementName['officeId']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            readonly
                                            v-model.number="form['officeId']"
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['officeId']"
                                            type="text"
                                        ></md-input>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('sourceId')"
                                    >
                                        <label>{{
                                            mapElementName['sourceId']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            readonly
                                            v-model.number="form['sourceId']"
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['sourceId']"
                                            type="text"
                                        ></md-input>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('chanPhone')"
                                    >
                                        <label>{{
                                            mapElementName['chanPhone']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            readonly
                                            v-model.number="form['chanPhone']"
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['chanPhone']"
                                            type="text"
                                        ></md-input>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="
                                            getValidationClass('sourceName')
                                        "
                                    >
                                        <label>{{
                                            mapElementName['sourceName']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            readonly
                                            v-model.number="form['sourceName']"
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['sourceName']"
                                            type="text"
                                        ></md-input>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('leadType')"
                                    >
                                        <label>{{
                                            mapElementName['leadType']
                                        }}</label>
                                        <md-select v-model="form.leadType">
                                            <md-option :value="''"
                                                >Не задано</md-option
                                            >
                                            <md-option
                                                :value="item.id"
                                                v-for="item in leadTypes"
                                                v-bind:key="item.id"
                                                >{{ item.leadTypeCode }} ({{
                                                    item.leadTypeName
                                                }})</md-option
                                            >
                                        </md-select>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="
                                            getValidationClass('description')
                                        "
                                    >
                                        <label>{{
                                            mapElementName['description']
                                        }}</label>
                                        <md-input
                                            v-if="action === 'delete'"
                                            readonly
                                            v-model.number="form['description']"
                                            type="text"
                                        ></md-input>
                                        <md-input
                                            v-else
                                            v-model="form['description']"
                                            type="text"
                                        ></md-input>
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('status')"
                                    >
                                        <label>{{
                                            mapElementName['status']
                                        }}</label>
                                        <md-select v-model="form.status">
                                            <md-option value="A"
                                                >Активный</md-option
                                            >
                                            <md-option value="I"
                                                >Неактивный</md-option
                                            >
                                        </md-select>
                                    </md-field>
                                </div>
                            </div>
                            <br />
                            <div
                                class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep"
                            >
                                <template v-if="chanel">
                                    <md-button
                                        v-if="action !== 'delete'"
                                        @click="validateData(saveItem)"
                                        class="md-button md-success md-theme-default"
                                    >
                                        Сохранить
                                    </md-button>

                                    <md-button
                                        v-if="action === 'delete'"
                                        @click="validateData(deleteItem)"
                                        class="md-button md-primary  md-theme-default"
                                    >
                                        Удалить
                                    </md-button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { checkAuthentication, reAuthenticate } from '@/utils/auth-api';
import { required } from 'vuelidate/lib/validators';
import { getItem, saveItem, deleteItem } from '@/utils/dict-api';

export default {
    mixins: [validationMixin],
    bodyClass: 'dictionary-data',
    props: ['page', 'action'],
    data() {
        return {
            chanel: false,
            mapElementName: {
                chanName: 'Название канала продаж',
                chanCode: 'Код',
                utmSubstring: 'UTM-метка',
                utmSource: 'UTM_SOURCE',
                officeId: 'ID офиса(office_id)',
                sourceId: 'ID источника(source_id)',
                chanPhone: 'КЦ телефон',
                sourceName: 'Источник',
                leadType: 'leadType',
                description: 'Описание',
            },
            form: {
                action: 'save',
                chanName: '',
                chanCode: +new Date(),
                leadType: '',
            },
            leadTypes: {},
        };
    },
    validations: {
        form: {
            chanCode: {
                required,
            },
            chanName: {
                required,
            },
            utmSubstring: {},
            utmSource: {},
            officeId: {},
            sourceId: {},
            sourceName: {},
            leadType: {},
            description: {},
            status: {},
        },
    },
    methods: {
        getValidationClass(fieldName) {
            const field = this.$v.form[fieldName];
            if (field) {
                return {
                    'md-invalid': field.$invalid && field.$dirty,
                };
            }
        },
        validateData(sendFn) {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                sendFn();
            }
        },
        setData: function(data) {
            this.form = data;
        },
        getElementData: function() {
            checkAuthentication(this.$router, this.$route).then(response => {
                getItem('leadtype')
                    .then(result => {
                        this.leadTypes = {};
                        for (let leadType of result) {
                            this.leadTypes[leadType.id] = leadType;
                        }
                        if (this.$route.params.id === 'new') {
                            this.addItem();
                            return;
                        }
                        checkAuthentication(this.$router, this.$route).then(
                            response => {
                                getItem('saleschannal')
                                    .then(result => {
                                        this.chanel = result.find(
                                            item =>
                                                +item.id ===
                                                +this.$route.params.id
                                        );
                                        if (this.chanel.leadType == null) {
                                            this.chanel.leadType = '';
                                        }
                                        this.setData(this.chanel);
                                    })
                                    .catch(error => {
                                        reAuthenticate(
                                            this.$router,
                                            this.$route,
                                            error
                                        );
                                    });
                            }
                        );
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        addItem: function() {
            const item = {
                id: 'new',
                chanCode: +new Date(),
                chanName: '',
                utmSubstring: '',
                utmSource: +new Date(),
                officeId: '1611',
                sourceId: '',
                sourceName: '',
                leadType: '',
                description: '',
                status: '',
            };
            this.setData(item);
            this.chanel = item;
        },
        saveItem: function() {
            if (this.form.id === 'new') {
                this.form.id = null;
            }
            if (this.form.leadType == '') {
                this.form.leadType = null;
            }
            checkAuthentication(this.$router, this.$route).then(response => {
                saveItem('saleschannal', JSON.stringify(this.form))
                    .then(result => {
                        this.$router.push({ name: 'saleschannalList' });
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        deleteItem: function() {
            checkAuthentication(this.$router, this.$route).then(response => {
                deleteItem(
                    'saleschannal',
                    JSON.stringify({ id: this.$route.params.id })
                )
                    .then(result => {
                        this.$router.push({ name: 'saleschannalList' });
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
    },
    created() {
        if (this.$route.params.action == 'delete') {
            this.deleteItem();
        } else {
            this.getElementData();
        }
    },
};
</script>

<style lang="scss" scoped type="text/scss">
.dictionary-data .md-field {
    padding-top: 16px;
    margin: 4px 0 24px;
}

.offset-left-16 {
    margin-left: 16px;
}
</style>
